import { withRouter } from "react-router";

const WithRouterHistory = (props: any) => <>{props.children(props.history)}</>;

export default withRouter(WithRouterHistory);
